import React from 'react';

export const ArabicPattern = ({ className = '' }) => {
  return (
    <div className={`absolute inset-0 overflow-hidden pointer-events-none ${className}`}>
      {/* Geometric Pattern inspired by Islamic art */}
      <svg className="absolute top-0 right-0 w-96 h-96 opacity-5" viewBox="0 0 200 200">
        <defs>
          <pattern id="arabicPattern" x="0" y="0" width="40" height="40" patternUnits="userSpaceOnUse">
            {/* Star pattern */}
            <path d="M20,5 L23,15 L33,15 L25,21 L28,31 L20,25 L12,31 L15,21 L7,15 L17,15 Z" 
                  fill="currentColor" className="text-teal-400" />
            {/* Connecting lines */}
            <circle cx="20" cy="20" r="15" fill="none" stroke="currentColor" 
                    strokeWidth="0.5" className="text-teal-400" opacity="0.3" />
          </pattern>
        </defs>
        <rect width="200" height="200" fill="url(#arabicPattern)" />
      </svg>

      {/* Corner decorations */}
      <svg className="absolute top-0 left-0 w-32 h-32 opacity-10 text-teal-400" viewBox="0 0 100 100">
        <path d="M0,0 L0,50 Q0,0 50,0 Z" fill="currentColor" />
        <path d="M10,10 L10,45 Q10,10 45,10 Z" fill="none" stroke="currentColor" strokeWidth="1" />
        <path d="M20,20 L20,40 Q20,20 40,20 Z" fill="none" stroke="currentColor" strokeWidth="1" />
      </svg>

      <svg className="absolute bottom-0 right-0 w-32 h-32 opacity-10 text-teal-400 transform rotate-180" viewBox="0 0 100 100">
        <path d="M0,0 L0,50 Q0,0 50,0 Z" fill="currentColor" />
        <path d="M10,10 L10,45 Q10,10 45,10 Z" fill="none" stroke="currentColor" strokeWidth="1" />
        <path d="M20,20 L20,40 Q20,20 40,20 Z" fill="none" stroke="currentColor" strokeWidth="1" />
      </svg>
    </div>
  );
};

export const ArabicBorder = ({ className = '' }) => {
  return (
    <div className={`relative ${className}`}>
      {/* Top border pattern */}
      <div className="absolute top-0 left-0 right-0 h-1 overflow-hidden">
        <svg className="w-full h-full" preserveAspectRatio="none" viewBox="0 0 1200 10">
          <defs>
            <pattern id="topBorder" x="0" y="0" width="40" height="10" patternUnits="userSpaceOnUse">
              <polygon points="0,5 10,0 20,5 10,10" fill="currentColor" className="text-teal-400" opacity="0.3" />
            </pattern>
          </defs>
          <rect width="1200" height="10" fill="url(#topBorder)" />
        </svg>
      </div>
    </div>
  );
};
